
export default class StoreWrap {
  reduxStore;
  unsubscribes:Array<Function> = [];
  visitHandler: () => void;
  getState = () => { return this._getState(); }
  dispatch = (action) => { return this._dispatch(action); }
  subscribe = (listener, permanent: boolean = false) => { return this._subscribe(listener, permanent); }
  replaceReducer = (nextReducer) => { return this._replaceReducer(nextReducer); }
  constructor(reduxStore){
    this.reduxStore = reduxStore;
  }
  _getState(){ return this.reduxStore.getState(); }
  _dispatch(action){ return this.reduxStore.dispatch(action); }
  _subscribe(listener, permanent: boolean = false) {
    if(!this.visitHandler){
      this.visitHandler = () => { this.beforeVisit() };
      document.addEventListener('turbolinks:before-visit', this.visitHandler);
    }
    let unsubscribe = this.reduxStore.subscribe(listener);
    if(!permanent){
      this.unsubscribes.push(unsubscribe);
    }
    return unsubscribe;
  }
  _replaceReducer(nextReducer) { return this.reduxStore.replaceReducer(nextReducer); }
  private beforeVisit(){
    for(let i = 0; i < this.unsubscribes.length; i++){
      this.unsubscribes[i]();
    }
  }
}
